import type { IGetPointsHistoryResponse, IMembershipTiersResponse } from '../types/tiers.types';
import apiClient from './client';

export const getPointHistory = async (entity_id: string) => {
  const resp = await apiClient.get<IGetPointsHistoryResponse>(`/membership/points/${entity_id}`);
  return resp.data;
};

export const getTiers = async (entity_id: string) => {
  const resp = await apiClient.get<IMembershipTiersResponse>(`/membership/tiers/${entity_id}`);
  return resp.data;
}
